import { cva } from 'class-variance-authority';
export const textStyling = cva('', {
    variants: {
        type: {
            h1: 'text-heading-3 text-fg',
            h2: 'text-heading-4 text-fg',
            h3: 'text-heading-5 text-fg',
            h4: 'text-body text-fg-muted font-medium',
            h5: 'text-body text-fg-muted font-medium',
            p: 'text-body text-fg-muted',
            s: 'text-body-sm text-fg-muted',
            xs: 'text-caption text-fg-muted',
            xxs: 'text-xxs text-fg-subtle',
        },
        weight: {
            light: 'font-light',
            normal: 'font-normal',
            medium: 'font-medium',
            semibold: 'font-semibold',
            bold: 'font-bold',
        },
    },
    defaultVariants: {
        type: 'p',
    },
});
